export interface AuditPresentationInput {
  action?: string;
  changes?: Record<string, unknown>;
  reason?: string;
}

export function humanizeAuditAction(action = ""): string {
  return action
    .replace(/[._-]+/g, " ")
    .replace(/\b\w/g, (letter) => letter.toUpperCase())
    .trim() || "Administrative change";
}

function readable(value: unknown): string {
  if (value == null || value === "") return "—";
  if (typeof value === "boolean") return value ? "Yes" : "No";
  if (typeof value === "string" || typeof value === "number") return String(value);
  if (Array.isArray(value)) return value.length > 5 ? `${value.length} records` : value.map(readable).join(", ");
  return "Updated structured information";
}

export function auditChangeRows(changes?: Record<string, unknown>): Array<{ label: string; value: string }> {
  if (!changes) return [];
  const preferred = ["from", "to", "status", "athleteId", "organizationId", "competitionId", "decision", "points", "version"];
  const keys = [...preferred.filter((key) => key in changes), ...Object.keys(changes).filter((key) => !preferred.includes(key))];
  return keys.slice(0, 8).map((key) => ({ label: humanizeAuditAction(key), value: readable(changes[key]) }));
}
